import { defineStore } from 'pinia';
import { debugLog } from '@/helpers/loggingFunctions.js';
import { fetchEndpoint } from '@/helpers/storeFunctions.js';
import { redirectRecognizedUser } from '@/helpers/recognizedEmailHelper.js';
import { parseFormData } from './applicationStore';
import { useUserStore } from '@/stores/userStore.js';

export const useAuthStore = defineStore('authStore', {
    state: () => ({
        token: '',
        user_id: null
    }),

    actions: {
        async verifyCredentials(credentials) {
            debugLog('authStore.verifyCredentials triggered');

            const verifyCredentialsResponse = await fetchEndpoint(
                this,
                'api/login',
                'post',
                credentials
            );

            const { status, data } = verifyCredentialsResponse;

            if (status === 'success' && data.user.email_confirmed) {
                this.setToken(data.access_token);

                const userStore = useUserStore();
                await userStore.setUser(data.user);
            }

            return verifyCredentialsResponse;
        },

        async register(registrationData) {
            try {
                const response = await fetchEndpoint(
                    this,
                    'api/register',
                    'post',
                    registrationData,
                    'profile'
                );

                const { status, data } = response;

                if (status === 'success') {
                    return data;
                }

                return false;
            } catch (error) {
                if (error?.data?.message === 'email_recognized') {
                    redirectRecognizedUser(error);
                }
                throw error;
            }
        },

        async storeRegisterData(data) {
            this.setToken(data.access_token);

            const userStore = useUserStore();
            userStore.setUser(data.user);
        },

        async forgotPassword(credentials) {
            debugLog('resources/js/stores/authStore.js - forgotPassword triggered');

            return fetchEndpoint(this, 'api/forgot-password', 'post', credentials);
        },

        async resetPassword(credentials) {
            debugLog('resources/js/stores/authStore.js - resetPassword triggered');

            return fetchEndpoint(this, 'api/reset-password', 'post', credentials);
        },

        async logout() {
            debugLog('resources/js/stores/authStore.js - logout triggered');

            return fetchEndpoint(this, 'api/logout', 'post');
        },

        setToken(token) {
            this.token = token;
            localStorage.setItem('access_token', token);
        },

        saveToLocalStorage() {
            try {
                const parsedData = parseFormData(this.$state);
                localStorage.setItem('authStore', JSON.stringify(parsedData));
            } catch (error) {
                console.error('Error saving to localStorage:', error);
            }
        },

        loadFromLocalStorage() {
            try {
                const savedState = localStorage.getItem('authStore');
                if (savedState) {
                    this.$patch(parseFormData(JSON.parse(savedState)));
                }
            } catch (error) {
                console.error('Error loading from localStorage:', error);
            }
        }
    }
});
